<template>
  <div class="big">
    <div class="container">
      <div>
        <div class="box">
          <div class="searchbox">
            <div class="item">
              <span>医生姓名</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_name"
                style="width: 150px; margin-left: 10px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>医生手机号</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_phone"
                style="width: 150px; margin-left: 10px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>患者姓名</span>
              <el-input
                placeholder="请输入"
                v-model="user_name"
                style="width: 160px; margin-left: 12px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>患者手机号</span>
              <el-input
                placeholder="请输入"
                v-model="phone"
                style="width: 160px; margin-left: 12px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>药品剂型</span>
              <el-select
                v-model="drug_type"
                placeholder="请选择"
                style="width: 150px; margin-left: 10px"
                clearable
                @change="search"
              >
                <el-option
                  v-for="item in options"
                  :key="item.drug_type"
                  :label="item.drug_type_name"
                  :value="item.drug_type"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span style="margin-right: 8px">药房名称</span>
              <!-- <el-input
                placeholder="请输入"
                v-model="hospital_name"
                style="width: 150px; margin-left: 12px"
                @input="search"
                clearable
              ></el-input> -->
              <myInputSerch
                v-model="hospital_name"
                @update="search"
              ></myInputSerch>
            </div>
            <div class="item">
              <span>提交时间</span>
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 264px; margin-left: 12px"
                @change="search"
                clearable
              ></el-date-picker>
            </div>
            <div class="item">
              <span>开方时间</span>
              <el-date-picker
                v-model="date2"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 264px; margin-left: 12px"
                @change="search"
                clearable
              ></el-date-picker>
            </div>
            <div class="item">
              <span>确认状态</span>
              <div style="padding-top: 3px; margin-left: 10px">
                <el-radio-group v-model="is_doctor_sure" @change="search">
                  <el-radio :label="''">全部</el-radio>
                  <el-radio :label="2">待确认</el-radio>
                  <el-radio :label="4">已驳回</el-radio>
                  <el-radio :label="3">已通过</el-radio>
                </el-radio-group>
              </div>
              <el-button
                type="info"
                style="
                  background-color: #eceff2;
                  color: #747981;
                  margin-left: 10px;
                "
                @click="search"
                >查询</el-button
              >
            </div>
          </div>
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column
                label="提交时间"
                prop="create_time"
              ></el-table-column>
              <el-table-column
                label="患者姓名"
                prop="user_name"
              ></el-table-column>
              <el-table-column label="性别">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.sex == 1">男</span>
                    <span v-if="scope.row.sex == 2">女</span>
                    <span v-if="scope.row.sex == 0">未知</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="年龄" prop="age"></el-table-column>
              <el-table-column label="手机号" prop="phone">
                <template slot-scope="scope">
                  <div class="align-center">
                    <span>{{ scope.row.phone }}</span>
                    <img
                      v-if="
                        scope.row.phone &&
                        (module_id_array[0]
                          ? module_id_array.includes('1756')
                          : true)
                      "
                      class="phone-box"
                      src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
                      alt
                      @click="callBtn(7, scope.row.pic_id)"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="处方图片">
                <template slot-scope="scope">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="scope.row.picture"
                    :preview-src-list="[scope.row.picture]"
                  ></el-image>
                </template>
              </el-table-column>
              <el-table-column label="剂型" prop="drug_type_name">
              </el-table-column>
              <el-table-column label="剂数" prop="total_num"></el-table-column>
              <el-table-column
                label="开方时间"
                prop="pre_create_time"
              ></el-table-column>
              <el-table-column label="处方状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.pre_status == 1">待取药</div>
                  <div v-if="scope.row.pre_status == 2">待审方</div>
                  <div v-if="scope.row.pre_status == 3">已通过</div>
                  <div v-if="scope.row.pre_status == 4">已抓药</div>
                  <div
                    v-if="
                      scope.row.pre_status == 5 ||
                      scope.row.pre_status == 6 ||
                      scope.row.pre_status == 7 ||
                      scope.row.pre_status == 8
                    "
                  >
                    已失效
                  </div>
                  <div>{{ scope.row.is_doctor_sure | doctorSureText }}</div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.pre_status == 1"
                    type="text"
                    @click="toVoid(scope.row.pre_id)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('314')
                        : false
                    "
                    >作废</el-button
                  >
                  <el-button
                    v-if="
                      scope.row.pre_status == 5 ||
                      scope.row.pre_status == 6 ||
                      scope.row.pre_status == 7 ||
                      scope.row.pre_status == 8
                    "
                    type="text"
                    @click="toPre(scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('314')
                        : false
                    "
                    >重新开方</el-button
                  >
                  <el-button
                    v-if="scope.row.pre_status == 1"
                    type="text"
                    @click="sendMsg(scope.row.pre_id)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('315')
                        : false
                    "
                    >再次发送</el-button
                  >
                  <el-button type="text" @click="toDetail(scope.row.pre_id)"
                    >查看处方</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
              style="margin: 20px 0"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import myInputSerch from "@/components/myInputSerch";
import moment from "moment";
import dayjs from "dayjs";
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      doctor_name: "",
      doctor_phone: "",
      hospital_name: "",
      drug_type: "",
      user_name: "",
      phone: "",
      date: [],
      date2: [],
      options: [],
      is_doctor_sure: "",
    };
  },
  components: {
    myInputSerch,
  },
  filters: {
    doctorSureText(val) {
      switch (val) {
        case 1:
          return "(无需确认)";
        case 2:
          return "(待确认)";
        case 3:
          return "(已确认)";
        case 4:
          return "(已驳回)";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        hospital_name: this.hospital_name,
        drug_type: this.drug_type,
        user_name: this.user_name,
        phone: this.phone,
        is_doctor_sure: this.is_doctor_sure,
        status: 2,
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.create_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      if (this.date2 && this.date2.length > 0) {
        data.pre_create_time_start = dayjs(this.date2[0]).format("YYYY-MM-DD");
        data.pre_create_time_end = dayjs(this.date2[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/photograph/getPrescriptionPictureList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = moment
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm");
              item.pre_create_time = moment
                .unix(item.pre_create_time)
                .format("YYYY-MM-DD HH:mm");
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //开方
    toPre(row) {
      this.$router.push({
        path: "saveprephoto",
        query: {
          row: JSON.stringify(row),
        },
      });
    },
    //查看处方
    toDetail(pre_id) {
      this.$router.push({
        path: "prephotodetail",
        query: {
          pre_id,
        },
      });
    },
    //发送
    sendMsg(pre_id) {
      this.axios
        .post("platform/photograph/sendPrescriptionSms", { pre_id })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("已发送");
          }
        });
    },
    //作废
    toVoid(pre_id) {
      this.$confirm("是否作废当前处方？", "确认作废", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.axios
            .post("platform/photograph/invalidPrescription", { pre_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("已作废");
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post("platform/photograph/getDrugTypeList", { platform_type })
        .then((res) => {
          this.options = res.data.list;
        });
    },
  },
  created() {
    this.getDrugTypeList();
  },
  activated() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 1px 20px;
  .phone-box {
    width: 18px;
    height: 18px;
    padding: 0 6px;
    cursor: pointer;
  }
  .searchbox {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .item {
      margin-right: 30px;
      margin-top: 24px;
      display: flex;
      align-items: center;
    }
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.dialog {
  padding: 20px 20px 0;
}
</style>
